import { useEffect, useState } from "react";
import { faqs } from "@/mocks/chigua";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import Categories from "./components/Categories";
import Timeline from "./components/Timeline";
import Gallery from "./components/Gallery";
import Feed from "./components/Feed";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";

function JsonLd() {
  const webSite = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        name: "吃瓜图集",
        url: "https://tiankea.cn/",
        logo: "https://tiankea.cn/logo.png",
        description: "按事件整理聊天记录、朋友圈、微博与评论等公开信息截图的内容聚合门户。",
      },
      {
        "@type": "WebSite",
        name: "吃瓜图集",
        url: "https://tiankea.cn/",
        inLanguage: "zh-CN",
      },
      {
        "@type": "CollectionPage",
        name: "吃瓜图集首页",
        url: "https://tiankea.cn/",
        about: "吃瓜图集：聊天记录、朋友圈、微博截图、爆料截图按事件整理与持续收录。",
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  };
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(webSite) }}
    />
  );
}

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg" />
    </a>
  );
}

export default function Home() {
  return (
    <>
      <JsonLd />
      <Header />
      <main>
        <Hero />
        <HotRank />
        <Categories />
        <Timeline />
        <Gallery />
        <Feed />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}